import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postAssets({ body }) {
  return BaseService.post(REST.ASSETS, body);
}

function putAssets({ body, id }) {
  return BaseService.put(REST.ASSETS_ID(id), body);
}

function getAssets(params) {
  return BaseService.get(REST.ASSETS, {
    params: paramsFilter({ params }),
  });
}

function deleteAssets({ id }) {
  return BaseService.delete(REST.ASSETS_ID(id));
}

export default {
  getAssets,
  putAssets,
  postAssets,
  deleteAssets,
};
